module.exports = __webpack_public_path__ + "files/2c1ea03043d76fc65767eb60aa6e0015.woff2";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Size3-Regular.woff2
// module id = 1165
// module chunks = 60